var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('gmap-map',{staticStyle:{"width":"100%","height":"600px"},attrs:{"zoom":16,"center":_vm.center}},_vm._l((_vm.locationMarkers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.position,"label":{
        text: m.vreme,
        color: 'white',
        fontWeight: 'bold',
        fontSize: '10px',
      }},on:{"click":function($event){_vm.center = m.position}}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }